import React from 'react';
import { Card, CardContent } from './ui/card';
import { studioInfo } from '../mock';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';

const Contact = () => {
  return (
    <section id="contact" className="py-20 px-6 bg-black">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-black text-white mb-4 uppercase tracking-tight">
            Find <span className="text-red-600">Us</span>
          </h2>
          <p className="text-xl text-gray-400">
            Visit our studio or get in touch
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Contact Information */}
          <div className="space-y-6">
            <Card className="bg-zinc-900 border-zinc-800">
              <CardContent className="pt-6 space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-red-600/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <MapPin className="w-6 h-6 text-red-600" />
                  </div>
                  <div>
                    <h3 className="text-white font-bold text-lg mb-1 uppercase">Location</h3>
                    <p className="text-gray-400">{studioInfo.address}</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-red-600/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Phone className="w-6 h-6 text-red-600" />
                  </div>
                  <div>
                    <h3 className="text-white font-bold text-lg mb-1 uppercase">Phone</h3>
                    <p className="text-gray-400">{studioInfo.phone}</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-red-600/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Mail className="w-6 h-6 text-red-600" />
                  </div>
                  <div>
                    <h3 className="text-white font-bold text-lg mb-1 uppercase">Email</h3>
                    <p className="text-gray-400">{studioInfo.email}</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-red-600/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Clock className="w-6 h-6 text-red-600" />
                  </div>
                  <div>
                    <h3 className="text-white font-bold text-lg mb-1 uppercase">Hours</h3>
                    <p className="text-gray-400">{studioInfo.hours}</p>
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* Quick Note */}
            <div className="bg-zinc-900 border border-zinc-800 rounded-lg p-6">
              <h3 className="text-xl font-black text-white mb-3 uppercase">
                Before You Visit
              </h3>
              <ul className="space-y-2 text-gray-400">
                <li className="flex items-start gap-2">
                  <span className="text-red-600 mt-1">•</span>
                  <span>Bring a valid ID (18+ for tattoos, 16+ for piercings with guardian)</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-red-600 mt-1">•</span>
                  <span>Reference images are always welcome</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-red-600 mt-1">•</span>
                  <span>Eat a good meal before your appointment</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-red-600 mt-1">•</span>
                  <span>Deposits are required for bookings over 2 hours</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Map */}
          <Card className="bg-zinc-900 border-zinc-800 overflow-hidden">
            <CardContent className="p-0">
              <div className="relative w-full h-full min-h-[500px]">
                {/* Mock Map - Replace with actual Google Maps embed when backend is ready */}
                <div className="absolute inset-0 bg-zinc-800 flex items-center justify-center">
                  <div className="text-center">
                    <MapPin className="w-16 h-16 text-red-600 mx-auto mb-4" />
                    <p className="text-white font-bold text-lg mb-2">Google Maps</p>
                    <p className="text-gray-400">Map integration will be added</p>
                  </div>
                </div>
                
                {/* Uncomment this when you have the actual address */}
                {/* <iframe
                  src="https://www.google.com/maps/embed?pb=YOUR_EMBED_CODE"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Studio Location"
                ></iframe> */}
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default Contact;
